import '../../styles/globals.css'
import { TextField, Button, Box, Typography, Paper, Grid } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

import giveDirectlyLogo from '../../images/causes/icons/give-directly.png';
import evidenceActionLogo from '../../images/causes/icons/evidence-action.png';
import coolEarthLogo from '../../images/causes/icons/cool-earth.png';
import wildAnimalInitiativeLogo from '../../images/causes/icons/wild-animal-initiative.png';
import cleanAirTaskForceLogo from '../../images/causes/icons/clean-air-taskforce.png';
import msfLogo from '../../images/causes/icons/msf.png';

// Import relevant icons
import { InlineIcon } from '@iconify/react';


function Donationlog(proof, index) {

    function convertDateTime(dateTime) {
        // Convert from 2023-10-05T20:07:59 to 2023-10-05
        return dateTime.split("T")[0];
    }

    function getCauseIcon(proof) {
        if (proof.causeName === "Give Directly") {
            return giveDirectlyLogo;
        }

        if (proof.causeName === "Evidence Action") {
            return evidenceActionLogo;
        }

        if (proof.causeName === "Cool Earth") {
            return coolEarthLogo;
        }

        if (proof.causeName === "Wild Animal Initiative") {
            return wildAnimalInitiativeLogo;
        }

        if (proof.causeName === "Clean Air Task Force") {
            return cleanAirTaskForceLogo;
        }

        if (proof.causeName === "MSF") {
            return msfLogo;
        }

        return null;
    }

    return (
        <>
            <a href={proof.url} target="_blank" rel="noreferrer">
                <img src={getCauseIcon(proof)} alt="logo" width={40} height={40} />
            </a>
            <Box key={proof.id || index}
                sx={{
                    maxWidth: "14.55rem",
                    minWidth: "14.55rem",
                    width: "100.0%",
                    justifyContent: "left",
                    alignItems: "left",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    marginRight: "0.5rem",
                    marginLeft: "0.75rem",
                    marginBottom: "0.375rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)",
                }}>
                <Grid container spacing={0}>
                    <Grid item xs={9} sm={9}>
                        <Box sx={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
                            {convertDateTime(proof.donationDateTime)}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
                            {proof.causeName === "MSF" ? "Doctors Without Borders" : proof.causeName}
                        </Box>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Box sx={{ width: "100%", height: "100%", justifyContent: "center", marginTop: "0.5rem" }}>
                            £{proof.donationAmount.toFixed(2)}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <a href={proof.donationURL} target="_blank" rel="noopener noreferrer">
                <InlineIcon className="red-icon" icon="simple-icons:go" style={{ fontSize: '1.75rem' }} />
            </a>
        </>
    );
}

function HomepageDonations() {

    const karmaContext = useKarmaPoolContext();

    const [donationProofs, setDonationProofs] = useState(null);

    const [backUrl, setBackUrl] = useState("/karma");

    useEffect(() => {
        karmaContext.donationProofManager.fetchLatestDonationProof();

        if (window.localStorage.getItem("jwtAuthToken") != null) {
            karmaContext.authPingManager.authPingSuccess(() => {
                console.log("auth ping success")
                setBackUrl("/karma/dashboard/pool")
            });
        }

    }, []);

    useEffect(() => {
        setDonationProofs(karmaContext.local.donationProofs);
    }, [karmaContext.local.donationProofs]);

    function renderDonationProofs() {
        console.log(donationProofs);

        if (donationProofs === undefined || donationProofs === null || donationProofs.length === 0) {
            return "Nothing yet :'(";
        }

        return (
            donationProofs.map((proof, index) => (
                <Box key={proof.id || index}
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                    {Donationlog(proof, index)}
                </Box>
            ))
        );
    };

    return (
        <>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Box sx={{ width: "90%" }} >
                    <Typography variant="h5" sx={{ marginTop: "0.0em" }}>
                        <strong>Karma Pool</strong>
                    </Typography>
                    <Paper sx={{ marginTop: "1.5rem" }} />
                    <Box sx={{ width: "100%", justifyContent: "center", display: "flex", alignContent: "center" }}>
                        <Box sx={{ maxWidth: "32rem" }} >
                            <Typography variant="body2" sx={{ marginTop: "0.0em" }}>
                                We are a members-only collective giving social media platform.
                                We aim to utilize technology to create a feedback loop of charitable giving.
                            </Typography>
                        </Box>
                    </Box>
                    <Paper sx={{ marginTop: "1.5rem" }} />

                    <Typography variant="body2" sx={{ marginTop: "0.0em" }}>
                        <strong>Donation Log</strong>
                    </Typography>
                    <Paper sx={{ marginTop: "0.75rem" }} />
                    <Box sx={{ width: "100%", justifyContent: "center", display: "flex", alignContent: "center" }}>
                        <Box sx={{ maxWidth: "32rem" }} >
                            <Typography variant="body2" sx={{ marginTop: "0.0em" }}>
                                You can find an audit of all our donations here.
                            </Typography>
                        </Box>
                    </Box>
                    <Paper sx={{ marginTop: "0.875rem" }} />
                    <Typography variant="body2" sx={{ marginTop: "0.0em" }}>
                        {renderDonationProofs()}
                    </Typography>
                    <Paper sx={{ marginTop: "2.0rem" }} />
                    <Box>
                        <p className={karmaStyles.homepageDescription}>
                            <Link to={backUrl}>
                                back
                            </Link>
                        </p>
                    </Box>
                    <Paper sx={{ marginTop: "3.5rem" }} />
                </Box>
            </Box>
        </>
    );
}

export default HomepageDonations;


